<template>
<div class="bodyclass">
<!--首页大框-->
<div class="top-box-ins"> 
  <!--菜单-->
  <div class="top-menu">
    <div class="top-menu-t clearfloat">
      <div class="menu-logo fl"></div>
      <div class="menu-txt fl">
        <ul class="li-div-txt">
          <li><a class="dbi fb w100 menu-atxt" href="/">首页</a></li>
          <li> <a class="dbi fb w100 menu-atxt" href="/chanping1">产品</a>
            <div class="li-div" style="width:1000px;">
              <div class="li-div-left fl"> <span class="tl dbi">产品</span> </div>
              <div class="w68 fl">
                <ul class="li-div-txt">
                  <li class="" style="width:23%"> 
                        <a class="dbi  w100 menu-atxt" href="/chanping4">
                          <div class="li-div-d2 mt10 "> 
                            <img src="../assets/images/z13-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">视觉智能体</h1>
                        </a> 
                      </li>
                      <li style="width:23%"> 
                        <a class="dbi w100 menu-atxt" href="/chanping3">
                          <div class="li-div-d2 mt10"> 
                            <img src="../assets/images/z12-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">新一代公共安全视觉智能体</h1>
                        </a> 
                      </li>
                  <li class="" style="width:23%"> <a class="dbi w100 menu-atxt" href="/chanping1">
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z1-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh20 mt10 dbi">谛视万象多模态视觉大模型</h1>
                    </a> </li>
                  <li style="width:23%"><a class="dbi  w100 menu-atxt" href="/chanping2" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z2-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh20 mt10 dbi">谛视万象多模态视觉大模型</h1>
                    </a> </li>
                </ul>
              </div>
            </div>
          </li>
          <li><a class="dbi fb w100 menu-atxt" href="/jiejfa1">解决方案</a>
            <div class="li-div" style="width:1300px;">
              <div class="li-div-left fl" style="width:220px" > <span class="tl dbi">解决方案</span> </div>
              <div class="w70 fl" style="height:148px;">
                <ul class="">
                  <li> <a class="dbi  w100 menu-atxt" href="/jiejfa1" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z3-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40 ">公共安全行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/yijii2">
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z4-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">应急行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/chengguan3" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z5-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">城管行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/jiaotong4" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z6-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">交通行业解决方案</h1>
                    </a> </li>
                  <li> <a class="dbi  w100 menu-atxt" href="/qiyeigl5" >
                    <div class="li-div-d2 mt10 "> <img src="../assets/images/z7-ytj.png"  class="li-div-img"></div>
                    <h1 class="f16 lh40">企业管理解决方案</h1>
                    </a> </li>
                </ul>
              </div>
            </div>
          </li>
          <li><a class="dbi fb w100 menu-atxt" href="/severHtml">服务&生态</a></li>
          <li><a class="dbi fb w100 menu-atxt" href="/gywmHtml">关于我们</a></li>
        </ul>
      </div>
    </div>
  </div>
  <!--菜单end--> 
  
  <!--背景图-->
  <div class="top-backgr">
    <div class="top-box-ins-img bgimg"  ></div>
    <div class="top-box-ins-imga1 bgimg2"  ></div>
  </div>
  <!--背景图end--> 
  
  <!--首页大框end--> 
</div>
<!--首页大框--> 
<!--内容大框-->
<div class="main pt84"> 
  <div class="w100 lh40 tc WOW animate__animated animate__fadeInUp"> 
    <span class="db f48 fb lp2 mt40">视觉智能体</span> 
    <span class="db f24  lp2 mt10 col-gr">Visual Intelligent Agent</span> 
  </div>
  <div class="w80 jz mt40 lh30 f16">
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">产品介绍</p>
    <p class="tl mb40 WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">产品创新融合混合专家模式与思维链推理技术，构建多模态视觉智能分析智能体，通过文字描述的方式，分钟级创建算法并无需任何样本训练，实现对公共安全、应急管理、交通运输、水利水务、能源电力和企业管理等众多领域视觉场景中的特征、行为及事件的实时感知。产品可高效连接各类感知设备，也可与无人机、机器人、机器狗、智能穿戴设备等无缝对接，共同形成感知、研判、处置的业务闭环，全面提升客户风险管控与业务管理能力。</p>
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品能力</p>
    <p class="f16 fb  tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;color:rgb(255,0,0);" >识万物、辨场景、擅推理</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">该产品可精准识别预定义目标，还能依自然语言实现开放域场景自适应感知，大幅拓展视觉应用灵活性与覆盖范围。它通过自主创新技术架构，突破传统模型处理新兴目标、复杂场景及行为组合的瓶颈，全方位提升跨领域视觉任务效能，提供更高效精准感知方案。</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">复杂场景算法零样本生成</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品无需复杂样本训练，用户仅靠简洁文字描述，就能快速完成场景算法的增、删、改、査操作。同时，产品支持多解析器与多提示词，可通过多条件叠加灵活构建复杂算法逻辑，高效适配多样化场景需求。</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">全量结构化分析</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品可对人、车、设备等万物进行全维度结构化处理，不仅能提取基本特征，还可识别行为、环境等内容，且支持用户完全自定义、交互上可用文字对话检索信息，也能通过语音调度任务，检索维度涵盖时间、地点、行为等多条件。</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">多种模式场景应用</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品支持实时布控预警、现场指挥调度、智能终端联动三大核心应用模式，三者协同发力:可借实时监测预警防风险，凭现场视觉数据分析提升指挥效率，还能联通机器狗、机器人、无人机等带摄像头智能终端，实现具身智能场景应用。</p>
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品优势</p>
    <img src="../assets/images/znyt_cpys_1.png" style="width:90%;">
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">核心技术</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">视觉原子识别</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">多智能体融合通过异构专家系统协同实现多智能体融合通过智能体间的竞争-协作平衡，显著提升复杂场景下的综合认知性能。</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">专家能力矩阵</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品的专家能力矩阵通过模块化专家网络协同动态分配，构建兼具通用认知与专业深度的智能中枢，实现复杂场景下的高阶视觉分析与决策</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">思维智慧推理</p>
    <p class="tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">基于多模态认知架构，通过深度语义理解与逻辑关联分析，实现高阶推理，理解隐含逻辑，完成复杂场景下的认知推断与策略生成。</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">多智能体融合</p>
    <p class="f16 fb mt20 tl WOW animate__animated animate__fadeInUp" style="animation-delay: 0.7s;color:rgb(255,0,0);">从海量数据中学习细粒度的视觉概念，建立物体、属性及局部特征的精准关联，支撑高精度任务，推动视觉智能迈向原子级感知新阶段</p>
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.5s;">产品架构</p>
    <img src="../assets/images/znyt_jgt.png" style="width:100%;">
  </div>
  <div class="w100 lh40 tc WOW animate__animated animate__fadeInUp"> 
    <span class="db f48 fb lp2 mt40">视觉智能体一体机</span> 
    <span class="db f24  lp2 mt10 col-gr">Visual Intelligent Agent All-in-One Machine</span> 
  </div>
  <div class="w90 jz mt40 lh30 f16">
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">产品介绍</p>
    <p class="tl mb40 WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">产品是集成了视觉智能体与高性能计算硬件的一站式智能设备专为复杂场景下的视觉分析任务设计。以视觉感知能力为核心，融合前沿科技实现对公共安全、应急管理、交通运输、水利水务、能源电力和企业管理等各领域视觉场景中的特征、行为及事件实时感知。产品精准洞察各类场景异常，为用户提供开箱即用的视觉分析服务，无需复杂部署，助力各行业智能化升级与跨越式发展。</p>
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">典型场景</p>
    <img src="../assets/images/znyt_dxcj_1.png" style="width:100%;">
    <p class="f20 fb mb30 tc WOW animate__animated animate__fadeInUp" style="animation-delay: 0.3s;">典型算法</p>
    <img src="../assets/images/znyt_dxsf.jpg" style="width:100%;">
  </div>
</div>
<!--内容大框end--> 
<!--底宣-->
<div class="btto-a1 mt100 ov">
      <div class="btto-a2 jz mt30">
        <ul class="w100 he68">
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;">
            <div class="btt-ico fl ">
              <img src="../assets/images/za1-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">全场景算法</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">algorithm</span>
              </div>
              <div class="mt4 col-gr3">多种行业全场景算法</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.3s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za2-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">算法灵活自定义</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Custom</span>
              </div>
              <div class="mt4 col-gr3">可通过文字自定义描述方式新增修改</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.5s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za3-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">国产化生态支持</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">support</span>
              </div>
              <div class="mt4 col-gr3">基于自主可控的国产化IT底层架构</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.7s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za4-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">完善标准化</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">standardization</span>
              </div>
              <div class="mt4 col-gr3">支持主流音视频标准化协议</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.9s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za5-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">大模型技术</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Large Model</span>
              </div>
              <div class="mt4 col-gr3">使用Transformer架构</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
<!--底宣end--> 
 <!--底宣2-->
    <div class="btto-b-a1 ov">
      <div class="mt30 w100 jz dbi">
        <div class="tc WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;"> <img src="../assets/images/ying-28.jpg" width="76" height="76" alt="" class="  dbi " /></div>
        <ul class="w100 he92 tc mt20">
          <li class=" WOW animate__animated animate__fadeInRight animate__duration-5s dbi" style="animation-delay: 0.1s;">
            <div class="tl f24 white he35 fl">上海谛视万象科技有限公司</div>
            <div class="ov  fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_3.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">联系电话：4007628008</span>
            </div>
          <!--  <div class="ov fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_1.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">地址：上海市普陀区真北路2653号天地科技园</span>
            </div>-->
          </li>
                   
        </ul>
      </div>
    </div>
    <!--底宣2end--> 
<!--底宣3-->
<div class="he90 tc btto-c"><span class="dbi col-gr3  mt30 mr40">辽ICP备2025061615号</span> <span class="dbi col-gr3  mt30">Copyright © 2004 - 2025 谛视万象版权所有</span></div>
<!--底宣3end-->
</div>
</template>
<script setup>
// , onUpdated, onUnmounted, ref
import { onMounted } from 'vue';
import * as WOW from 'wowjs';
// let wowInstance = null;
onMounted(() => {
    new WOW.WOW({
        // boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 50,       // 元素进入视口 100px 后触发
        // mobile: true,      // 移动端启用
        live: true,        // 监听动态添加的元素
    }).init();
})
</script>
<style scoped>
@import '@/assets/css/default.css';
@import '@/assets/css/font-awesome.min.css';
@import '@/assets/css/margin.css';
@import '@/assets/css/main.css';

/* style="background:url(../assets/images/bana-9.jpg) center center no-repeat;background-size:cover;" */
/* style="background:url(../assets/images/z8-ytj.png) center center no-repeat;background-size:cover;" */
.bgimg{
    background:url(../assets/images/bana-9.jpg) center center no-repeat;
    background-size:cover;
}

.bgimg2{
    background:url(../assets/images/z8-ytj.png) center center no-repeat;
    background-size:cover;
}

.animate__animated {
  animation-duration: 2s !important;
}

</style>